import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, PLATFORM_ID, effect } from '@angular/core';
import { NotificationModel } from './notification.model';
import { NotificationService } from './notification.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'iho-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent  {

  notifications: NotificationModel[] = [];

  constructor(
    private _notificationSvc: NotificationService,
    private cdRef:ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object
    ) {
    effect(() => {
      const notification = this._notificationSvc.getNotifications();
      if (notification()) {
        this._addNotification(notification())
      }
    });
   }
  

  private _addNotification(notification: NotificationModel) {
    this.notifications.push(notification);

    if (notification.timeout !== 0 && isPlatformBrowser(this.platformId)) {
      setTimeout(() => this.close(notification), notification.timeout);
    }
    this.cdRef.detectChanges();

  }

  // ngOnDestroy() {
  // }

  close(notification: NotificationModel) {
    this.notifications = this.notifications.filter(notif => notif.id !== notification.id);
    this.cdRef.detectChanges();
  }

}
